module.exports = __webpack_public_path__ + "img/05100023.3a1b03f9.jpg";